
    import { Component, Vue } from "vue-property-decorator";
    import moment from "moment";
    import { namespace } from "vuex-class";
    import { ScheduleActualCIOD } from "@/models";
    import ErrorNotification from "@/views/shared/ErrorNotification.vue";
    import { useAppInsights } from '../../store/modules/AppInsights'
    const profile = namespace("profile");
    const schedule = namespace("schedule");
    @Component({ components: { ErrorNotification } })
    export default class PayrollDetails extends Vue {
        @profile.State
        public profileData!: any;
        @schedule.State
        public userSchedules!: any;
        @schedule.State
        public payrollDetails!: ScheduleActualCIOD[];
        @profile.State
        appInsightEventData!: any;
        fromDateVal: string = new Date().toISOString().substr(0, 10);
        toDateVal: string = new Date().toISOString().substr(0, 10);
        errorMsg: string = '';
        errorType: string = 'error';
        showErrorMsg: boolean = false;
        
        async mounted() { 
            this.getCurrentPayperiod();             
        }

        async getCurrentPayperiod() {
            if (this.userSchedules.length == 0) {
                var payload = {
                    username: this.profileData.username,
                    index: 0,
                };

                await this.$store.dispatch("schedule/getAllUserSchedules", payload);
            }
            if (this.userSchedules.length != 0) {
                let currDt = new Date(new Date().setHours(0,0,0,0));
                let currsched;
                this.userSchedules.forEach((sched: any) => {
                    let startDt, endDt;
                    startDt = sched.startDate;
                    endDt = sched.endDate;
                    if (new Date(startDt) <= new Date(currDt) &&
                        new Date(endDt) >= new Date(currDt)) //
                    {
                        currsched = sched;
                        var PayperiodCount = (this.profileData.weeksInSchedule / 2);
                        var sdate = new Date(currsched.startDate);
                        var payperiodStartDate!: any;
                        var payperiodEndDate!: any;
                        for (var i = 0; i < PayperiodCount; i++) {
                            if (i == 0) {
                                payperiodStartDate = sdate;
                                payperiodEndDate = moment(sdate).add(13, 'days');
                            }
                            else {
                                payperiodStartDate = moment(payperiodStartDate).add(14, 'days');
                                payperiodEndDate = moment(payperiodStartDate).add(13, 'days');
                            }
                            if (new Date(payperiodStartDate) <= new Date(currDt) &&
                                new Date(payperiodEndDate) >= new Date(currDt)) {
                                this.fromDateVal = new Date(payperiodStartDate).toISOString().substr(0, 10);
                                this.toDateVal = new Date(payperiodEndDate).toISOString().substr(0, 10);
                                this.getPayrollDetails();
                                break;
                            }
                        }
                        return;
                    }
                });
            }
        }

        async getPayrollDetails() {
            if (this.validateDates()) {
                var payload = {
                    startDate: this.fromDateVal,
                    endDate: this.toDateVal,
                    username: this.profileData.username,
                };
                
                await this.$store.dispatch('schedule/getPayrollDetails', payload)
                    .then((res: any) => {
                        
                    })
                    .catch((err: any) => {
                        if (err) {
                            console.log(err);
                        }
                    });
            }
        }
        validateDates() {
            var fromDt = moment(this.fromDateVal, 'YYYY-MM-DD');
            var toDt = moment(this.toDateVal, 'YYYY-MM-DD');
            if (fromDt.isValid() == false || toDt.isValid() == false) {
                this.showErrorMsg = true;
                if (fromDt.isValid() == true && toDt.isValid() == false) {
                    this.errorMsg = "Please enter valid To Date"
                }
                else if (fromDt.isValid() == false && toDt.isValid() == true) {
                    this.errorMsg = "Please enter valid From Date"
                }
                else {
                    this.errorMsg = "Please enter valid From and To Dates"
                }
            }
            else {
                var dateDiff = moment.duration(toDt.diff(fromDt)).asDays();
                if (dateDiff > 14) {
                    this.showErrorMsg = true;
                    this.errorMsg = "Date Range cannot be greater than 14 days."
                }
                else if (dateDiff <= 0) {
                    this.showErrorMsg = true;
                    this.errorMsg = "To Date should be greater than From Date."
                }
                else {
                    this.showErrorMsg = false;
                }
            }
            if (this.showErrorMsg) {
                return false;
            }
            else {
                return true;
            }
        }
        formatDate(date: Date): string {
            return moment(date).format("dddd, MMMM DD yyyy");
        }
        formatTime(t: Date): string {
            return moment(t).format("h:mm A");
        }
        totalHours(sDate: Date, eDate: Date) {
            var totalHours = "0.00";

            if(sDate != null && eDate != null){
                var sDateVal: any = new Date(new Date(sDate).setSeconds(0,0));
                var eDateVal: any = new Date(new Date(eDate).setSeconds(0,0));
                totalHours = (Math.abs(sDateVal - eDateVal) / 36e5).toFixed(2);
            }
             
            return totalHours;
        }
    }
